import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import hoistNonReactStatic from 'hoist-non-react-statics'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { updateViewportDimensions, orientationChanged } from './deviceActions'
import getDisplayName from 'recompose/getDisplayName'

/**
 * Used by the entry-component in an app to
 * update Redux state "device" slice's
 * viewportWidth/viewportHeight
 *
 * Allows us to avoid redundancy with
 * re-implementing this logic on every component
 *
 * @param WrappedComponent
 * @returns {*}
 */
export default function withDeviceDimensions(WrappedComponent) {
    // wrap our component with a class that works with
    // device dimension components
    class WithDeviceDimensions extends PureComponent {
        static displayName = `withDeviceDimensions${getDisplayName(WrappedComponent)}`

        constructor(props) {
            super(props)

            this.updateViewportDimensions = this.updateViewportDimensions.bind(this)
            this.handleOrientationChange = this.handleOrientationChange.bind(this)
        }

        updateViewportDimensions = () => {
            this.props.updateViewportDimensions()
        }
        handleOrientationChange = e => {
            this.props.orientationChanged()
        }
        componentDidMount() {
            this.updateViewportDimensions()
            window.addEventListener('resize', this.updateViewportDimensions)
            window.addEventListener('orientationchange', this.handleOrientationChange)
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.updateViewportDimensions)
            window.removeEventListener('orientationchange', this.handleOrientationChange)
        }
        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    // then, re-add it's component statics (that aren't react lifecycle methods)
    const ComponentWithStatics = hoistNonReactStatic(WithDeviceDimensions, WrappedComponent)

    // finally return it with device related redux props
    return connect(
        mapSelectorsToProps(['viewportWidth', 'viewportHeight']),
        { updateViewportDimensions, orientationChanged }
    )(ComponentWithStatics)
}
